// HTTP authentication provider — the drop-in replacement for the mock provider
// once a backend exists (Phase C). NOT used in Phase A; select it with
// VITE_AUTH_PROVIDER=http when the API is available.
//
// Expected API:
//   POST /api/auth/login    { username, password }  → 200 { user:{id,name,role}, token }
//                                                      401 { error }
//   POST /api/auth/logout   (Authorization: Bearer <token>)
//   GET  /api/auth/session  (Authorization: Bearer <token>) → 200 | 401
// Roles are decided by the server. The client never decides who is an admin.
import { AuthError } from './mockAuthProvider.js';

export function createHttpAuthProvider({ baseUrl = '', fetchImpl = globalThis.fetch } = {}) {
  const call = (path, opts = {}) => fetchImpl(`${baseUrl}${path}`, { credentials: 'include', headers: { 'content-type': 'application/json', ...(opts.token ? { authorization: `Bearer ${opts.token}` } : {}) }, method: opts.method || 'GET', body: opts.body ? JSON.stringify(opts.body) : undefined });
  return {
    name: 'http',
    developmentOnly: false,
    async login({ username, password } = {}) {
      const r = await call('/api/auth/login', { method: 'POST', body: { username, password } });
      if (r.status === 401) throw new AuthError('denied', 'Sign-in failed. Check your username and password.');
      if (!r.ok) throw new AuthError('server', `Sign-in service error (${r.status}).`);
      const { user, token } = await r.json();
      return { user, token };
    },
    async logout(session) { await call('/api/auth/logout', { method: 'POST', token: session?.token }).catch(() => {}); },
    async validate(session) {
      const r = await call('/api/auth/session', { token: session?.token }).catch(() => null);
      return !!r?.ok;
    },
  };
}
